import { ThemeOptions } from '@mui/material';
// When using TypeScript 4.x and above
import type {} from '@mui/x-date-pickers/themeAugmentation';
// import '@mui/x-date-pickers/themeAugmentation';

import paletteConfig from './palette';
import typography from './typography';
import breakpoints from './breakpoints';
import { ThemeAdditional } from './@types';
import fontsConfig from './fonts';
import MuiButtonConfig from './components/MuiButton';
import MuiPickersDayConfig from './components/MuiDatePicker/MuiPickersDay';
import MuiSelectConfig from './components/MuiSelect';
import MuiAccordionConfig from './components/MuiAccordion';
import MuiLinkConfig from './components/MuiLink';

const themeAdditionalConfig: ThemeAdditional = {
  fonts: fontsConfig,
};

const theme: ThemeOptions = {
  spacing: 1,
  palette: paletteConfig,
  typography,
  breakpoints: {
    values: breakpoints,
  },
  shape: {
    // borderRadius: 48,
  },
  components: {
    MuiButton: MuiButtonConfig,
    // MuiDatePicker: {},
    MuiPickersDay: MuiPickersDayConfig,
    MuiSelect: MuiSelectConfig,
    MuiAccordion: MuiAccordionConfig,
    MuiLink: MuiLinkConfig,
  },
};

export default theme;
export { themeAdditionalConfig };
